import { Resizer } from 'components/base/Resizer'
import { PCPoint } from 'components/point'
import { SPPoint } from 'components/point-sp'
import { Fragment } from 'react'

export default function PointPage() {
  return (
    <Fragment>
      <div style={{ display: 'none' }}>
        <img src='/images/assets/bot_point.webp' alt='bot' />
      </div>
      <div className='pc-version'>
        <PCPoint />
      </div>
      <div className='sp-version'>
        <SPPoint />
      </div>
      <Resizer />
    </Fragment>
  )
}
